<div class="metric-card" style="height: 100%; width: 100%; margin-right: 1%">
  <!-- Cost Breakdown section fills all remaining height -->
  <div class="d-flex flex-column flex-grow-1">
    <div
      class="d-flex justify-content-between align-items-center pb-3 mb-3 chart-header-border"
    >
      <div class="d-flex align-items-center">
        <div class="chart-icon-container me-3 insight-icon">
          <i class="bi bi-bar-chart"></i>
        </div>
        <h3 class="chart-title mb-0">Calculated Cost Per Product</h3>
      </div>
    </div>

    <!-- This stack distributes space evenly among items -->
    <div class="d-flex flex-column flex-grow-1">
      <div
        *ngFor="let category of categories"
        class="bg-light-hover p-1 rounded-2 d-flex flex-column justify-content-between flex-grow-1"
      >
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center gap-2 p-2">
            <i [class]="category.iconClass" [ngClass]="category.iconColor"></i>
            <div>
              <h6 class="fw-semibold mb-0">{{ category.title }}</h6>
              <span class="text-muted small">
                {{ category.percentage.toFixed(1) }}% of total
              </span>
            </div>
          </div>
          <span class="fw-semibold">
            {{
              category.amount.toFixed(2) | currency : "ZAR" : "symbol" : "1.2-2"
            }}
          </span>
        </div>
        <div class="progress mt-2" style="height: 12px; border-radius: 4px">
          <div
            class="progress-bar"
            [ngClass]="category.progressClass"
            [style.width.%]="category.percentage"
          ></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Fixed Total Cost at the bottom -->
  <div class="border-top pt-3 mt-2">
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="fw-semibold mb-0">Total Cost</h5>
      <h3 class="text-primary fw-bold mb-0">
        {{ totalCost.toFixed(2) | currency : "ZAR" : "symbol" : "1.2-2" }}
      </h3>
    </div>
  </div>
</div>
